import { render } from "./taskinfo.vue?vue&type=template&id=364df476&scoped=true&ts=true"
import script from "./taskinfo.vue?vue&type=script&lang=ts"
export * from "./taskinfo.vue?vue&type=script&lang=ts"

import "./taskinfo.vue?vue&type=style&index=0&id=364df476&lang=scss&scoped=true"

import exportComponent from "D:\\ct-construction-ts-mobile\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-364df476"]])

export default __exports__